/* eslint-disable import/no-anonymous-default-export */

import moment from 'moment';
import fields from "./fields.utils.js";

const schema_hgv = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "licence_type": {
        label: "Licence type",
        type: 'select',
        value: '',
        options: [],
        required: true
    },
    "licence_date": {
        label: "Licence date",
        value: '',
        type: 'date-mask',
        required: true,

        placeholder: 'Licence Date'
    },
    "claim_x_type": {
        label: "Type",
        type: 'select',
        value: '',
        options: [],
        orderOptions: false,
        placeholder: 'Claim Type'
    },
    "claim_x_date": {
        label: "Date",
        type: 'date-mask',
        value: moment().format("DD/MM/YYYY"),

        placeholder: 'Claim Date'
    },
    "conviction_x_type": {
        label: "Conviction Type",
        type: 'select',
        value: '',
        options: [],

        placeholder: 'Conviction Type'
    },
    "conviction_x_points": {
        label: "Conviction points",
        type: 'number',
        value: 0,

        placeholder: 'Conviction Points'
    },
    "driver_x_name": {
        label: "Name",
        value: '',
        type: 'text',

        placeholder: 'Name'
    },
    "driver_x_date_of_birth": {
        label: "Date of birth",
        type: 'date-mask',
        value: '',

        placeholder: 'Date of Birth'
    },
    "driver_x_licence_type": {
        label: "Licence type",
        type: 'select',
        value: '',
        options: [],
    },
    "driver_x_licence_date": {
        label: "Licence date",
        value: '',
        type: 'date-mask',
        placeholder: 'Licence Date'
    },
    "owner": {
        label: 'Owner',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "body_type": {
        label: 'Body Type',
        type: 'select',
        value: '',
        options: [],
        required: true
    },
    "weight_over_75": {
        label: 'Is the vehicle\'s gross weight 7.5 tonne or more?',
        type: 'bool',
        value: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    "ops_licence": {
        label: 'OPS Licence',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "ops_licence_pending": {
        label: 'OPS Licence Pending',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "business_use": {
        label: 'Business Use',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "haulage_use": {
        label: 'Haulage Use',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "hgv_licence": {
        label: 'HGV Licence',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "hgv_licence_date": {
        label: 'HGV Licence Date',
        type: 'date-mask',
        value: '',
        required: true,
        placeholder: 'Hgv licence date'
    },
    "lgv_licence": {
        label: 'LGV Licence',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "lgv_licence_date": {
        label: 'LGV Licence Date',
        type: 'date-mask',
        value: '',
        required: true,
        placeholder: 'lgv licence date'
    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,

        placeholder: 'Cover Date'
    },
    "cover_type": {
        label: 'Cover Type',
        type: 'select',
        value: '',
        options: [],
        required: true,

    },
    ...fields.marketing,
    "vrm": {
        type: 'vehicle-lookup',
        value: '',
        required: true,

        placeholder: 'Registration Number'
    },
    "make": {
        label: 'make',
        type: 'select',
        value: '',
        options: [],
        placeholder: 'Make',
    },
    "model": {
        label: 'Model',
        type: 'text',
        value: '',
        placeholder: 'Model',
    },
    "year": {
        label: 'What is the vehicle manufacture year?',
        type: 'number',
        value: '',
        placeholder: 'Year'
    },
    ...fields.title,
    ...fields.cross_selling
};
export default schema_hgv;
